module.exports = __webpack_public_path__ + "img/hungary.f60200af.png";